// Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import ContactForm from './ContactForm';
import '../styles/Footer.css';
import '../styles/ContactForm.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links-extended">
          <div className="footer-link-column">
            <h4>Aktienanalyse</h4>
            <Link to="/search" className="footer-link">Aktiensuche</Link>
            <Link to="/search-explained" className="footer-link">Suchkriterien verstehen</Link>
            <Link to="/value-investing" className="footer-link">Value Investing</Link>
          </div>

          <div className="footer-link-column">
            <h4>Portfolio</h4>
            <Link to="/portfolio" className="footer-link">Portfolio-Verwaltung</Link>
            <Link to="/articles" className="footer-link">Aktienanalysen</Link>
          </div>

          <div className="footer-link-column">
            <h4>Konto</h4>
            <Link to="/login" className="footer-link">Anmelden</Link>
            <Link to="/register" className="footer-link">Registrieren</Link>
          </div>

          <div className="footer-link-column">
            <h4>Rechtliches</h4>
            <Link to="/impressum" className="footer-link">Impressum</Link>
            <Link to="/datenschutz" className="footer-link">Datenschutz</Link>
          </div>

          <div className="footer-link-column contact-column">
            <ContactForm />
          </div>
        </div>

        <p className="footer-disclaimer">
          Alle Inhalte dienen ausschließlich der Information und stellen keine Anlageberatung dar.
          Investitionen bergen Risiken bis hin zum Totalverlust.
        </p>

        <div className="footer-content">
          <div className="footer-copyright">
            © {new Date().getFullYear()} DynaStoxx. Alle Rechte vorbehalten.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
